import React, { useEffect, useState } from 'react'
import MySelect from '../../../../../../../UI/form/MySelect'

const PaymentStatusSelect = ({ required, setValidate, setValueForm, forciblyValue, optionDefault, optionsDefault }) => {

	// console.log('forciblyValue', forciblyValue)

  	const [value, setValue] = useState(
		forciblyValue && forciblyValue === true ? 'yes' :
		forciblyValue === false ? 'no' : forciblyValue
	)
	const [validSelect, setValidSelect] = useState(false)
	const [options, setOptions] = useState([
		{
			id: 'payWait',
			name: 'Передано на оплату'
		},
		{
			id: 'scheduledPayment',
			name: 'Заплановано на оплату'
		},
		{
			id: 'pay',
			name: 'Сплачено'
		},
	])

	// useEffect(() => {
	// 	getUnitMeasures()
	// }, [])

	useEffect(() => {
		valid()
	}, [required, value])

	const getUnitMeasures = () => {
		// getGoodTypesAllAPI().then(data => {
		// 	setGoodTypes(data)
		// }).catch(e => {
		// 	// setError(responseError(e))
		// 	console.error(responseError(e))
		// })
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
				setValidSelect(true)
			} else {
				setValidate(false)
				setValidSelect(false)
			}
		} else {
			setValidate(true)
			setValidSelect(true)
		}
	}

  return (
    <MySelect
        value={value}
        label="Статус оплати"
        labelId="select__paymentStatus-label"
        id='select__paymentStatus'
        onChange = {e => {
			setValueForm(e)
            setValue(e)
			// setEvent({...event, categoryId: e})
		}}
        nameField='Статус оплати'
        // sx={{width: '200px'}}
		optionDefault={optionDefault ? optionDefault : null}
		optionsDefault={optionsDefault ? optionsDefault : null}
        options={
			options && options.length > 0 ? 
				options.map(option => {
            		return {id: option.id, name: option.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default PaymentStatusSelect